/** The capture dialog's open state and draft (1.N-1 deliverable 16): in memory, never browser storage. */

export interface CaptureState {
  readonly open: boolean;
  readonly draft: string;
  /** Bumped when the key is pressed while the dialog is open, so the input takes focus again. */
  readonly focusTick: number;
}

let state: CaptureState = { open: false, draft: '', focusTick: 0 };
const listeners = new Set<() => void>();

function set(next: CaptureState): void {
  state = next;
  for (const listener of listeners) listener();
}

export const getCapture = (): CaptureState => state;

export function subscribeCapture(listener: () => void): () => void {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

export function openCapture(): void {
  set({ ...state, open: true, focusTick: state.open ? state.focusTick + 1 : state.focusTick });
}

export function closeCapture(): void {
  if (state.open) set({ ...state, open: false });
}

export function setDraft(draft: string): void {
  if (draft !== state.draft) set({ ...state, draft });
}

/** For specs: back to a closed, empty store. */
export function resetCapture(): void {
  set({ open: false, draft: '', focusTick: 0 });
}
